import styled from "styled-components";
import InputMask from "react-input-mask";
import Select from 'react-select';


export const MainContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 100vh;
  width: 100%;
  max-width: 100vw;
  background: var(--app-bg);
`;

export const Container = styled.div`
  width: 600px;
  padding: 2em;
  border-radius: 20px;
  box-shadow: var(--shadow-md);
  z-index: 2;
  background: var(--surface-1);
  color: var(--text-primary);
  border: 1px solid var(--border-subtle);
  
  h3 {
    color: var(--text-heading);
  }

  max-width: 100%;
  box-sizing: border-box;

  @media screen and (max-width: 768px) {
    width: 100%;
    padding: 1.25rem;
  }
`;

export const InnerContainer = styled.div`
  display: flex;
  justify-content: space-between;
  margin: 0 auto;
  max-width: 600px;

  width: 100%;

  @media screen and (max-width: 768px) {
    flex-direction: column;
  }
`;

export const Column = styled.div`
  display: flex;
  flex-direction: column;
`;

export const Row = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  width: 80%;
  padding: 16px;
`;

export const Label = styled.label`
  margin-bottom: 10px;
  font-weight: 700;
`;

export const ShowInput = styled(InputMask)`
  padding: 10px;
  margin-bottom: 20px;
  
  border: 2px solid var(--border-default);
  border-radius: 4px;
  padding: 8px;
  font-size: 16px;
  outline: none;
  width: 350px;
  background: var(--input-bg);
  color: var(--text-primary);

  &::placeholder {
    color: var(--input-placeholder);
  }

  &:focus {
    border-color: var(--accent);
  }

  max-width: 100%;
  box-sizing: border-box;

  @media screen and (max-width: 768px) {
    width: 100%;
  }
`;

export const Input = styled(InputMask)`
  padding: 10px;
  margin-bottom: 20px;
  
  border: 2px solid var(--border-default);
  border-radius: 4px;
  padding: 8px;
  font-size: 16px;
  outline: none;
  width: 250px;
  background: var(--input-bg);
  color: var(--text-primary);

  &::placeholder {
    color: var(--input-placeholder);
  }

  &:focus {
    border-color: var(--accent);
  }
`;

export const Span = styled.span`
  color: var(--text-secondary);
`;

export const ButtonContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  width: 100%;
`;

export const ButtonDisplay = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-end;
  width: 102%;
`;

export const Button = styled.button`
  background-color: var(--accent);
  border-radius: 10px;
  box-shadow: var(--shadow-sm);
  color: var(--text-on-accent);
  cursor: pointer;
  display: inline-block;
  font-family: CerebriSans-Regular,-apple-system,system-ui,Roboto,sans-serif;
  padding: 7px 20px;
  text-align: center;
  text-decoration: none;
  transition: all 250ms;
  border: 0;
  font-size: 16px;
  user-select: none;
  -webkit-user-select: none;
  touch-action: manipulation;
  margin-top: 50px;
  margin-right: 16px;

  :hover {
  box-shadow: var(--shadow-md);
  transform: scale(1.02) ;
  }
`;

export const IndexContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background: var(--surface-2);
  width: 100%;
  height: 100%;
`;

export const ProfileContainerInfo = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  align-items: center;
  width: 900px;
  height: 1200px;
  padding: 4em;
  border-radius: 20px;
  box-shadow: var(--shadow-md);
  z-index: 2;
  background: var(--surface-1);
  border: 1px solid var(--border-subtle);
  max-height: 500px;

  h3 {
    display: flex;
    align-self: flex-start;
    color: var(--text-heading);
  }

  @media screen and (min-width: 1920px) {
    width: 1400px;
    height: 1500px;
    padding: 10em;
  }

  @media (max-width: 480px) {
    width: 100%;
    height: auto;
    padding: 2em;
    border-radius: 0;
    box-shadow: none;
    max-height: none;

    h3 {
      align-self: center;
    }
  }
`;


export const ButtonContainerIndex = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  align-items: center;
  width: 600px;
  padding: 2em;
  border-radius: 20px;
  box-shadow: var(--shadow-md);
  z-index: 2;
  background: var(--surface-1);
  border: 1px solid var(--border-subtle);

  h3 {
    color: var(--text-heading);
  }
`;

export const StyledSelect = styled(Select)`
  margin-bottom: 20px;
  width: 370px  ;
  border-radius: 4px;
  font-size: 16px;
  outline: none;

  &:focus {
    border-color: var(--accent);
  }
`;
